/* eslint-disable */
/**
 * @author Leonel Martinez
 * @description `Cover-to-cover service`
 * @exports C2CService
 */
import { API } from '@/services'
import { http } from "@/utils";

export const C2CService = {
  getC2C
};

function getC2C(c2cCode) {
  return http
    .get(API.C2C + '/' + c2cCode)
    .then(c2c => Promise.resolve(c2c.data))
    .catch(error => Promise.reject(error.response.data));
}
